import Layout from '../../../components/layouts/layout.comp'
import { useTranslation } from '../../../core/translation.core';
import { DocListFilter } from '../../../types/product';
import { useForm, UseFormReturn, useWatch } from 'react-hook-form';
import { useRouter } from 'next/router';
import PageNav from '../../../components/common/pageNav.comp';
import { useEffect, useRef, useState } from 'react';
import LocalePs from '../../../components/locale/localePs.core';
import Modal from '../../../components/reuseables/modal.comp';
import { LocaleText } from '../../../types/locale';
import useDeleteSalesLocation from '../../../hooks/salesLocation/useDeleteSales.hook';
import Spinner from '../../../components/loaders/Spinner';
import useListWarrantyClaim from '../../../hooks/warranty/useGetWarranty.hook';
import CheckIcon from '../../../icons/check.icon';

export default function LocationPage() {
  const { t, msg } = useTranslation();
  const methods = useFormPagination()

  return (
    <Layout
      title={t(msg.product.warranty)}
    >
      <section className='container mx-auto'>
        <WarrantyHeader />
        <WarrantyBody methods={methods} />
        <Paging methods={methods} />
      </section>
    </Layout>
  )
}



function WarrantyHeader() {
  const { t, msg } = useTranslation();
  return (
    <section data-type="section" className="gap-3 space-y-2 items-end rounded-lg lg:visible hidden lg:grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr] lg:gap-2">
      <div>{t(msg.pay.name)}</div>
      <div>{t(msg.pickupAddr.tel)}</div>
      <div>{t(msg.setting.email)}</div>
      <div>{t(msg.reward.purchaseDate)}</div>
      <div>{t(msg.product.serialNumber)}</div>
      <div>{t(msg.receiptTemplate.receiptMediaUrl)}</div>
      <div>{t(msg.inventory.action)}</div>
    </section>
  )
}


function WarrantyBody({ methods }: { methods: UseFormReturn<DocListFilter, any> }) {
  const { data } = useListWarrantyClaim(methods);

  return (
    <div className='mt-5'>
      {data?.list?.map(warranty => (
        <Content
          key={Math.random()}
          warranty={warranty} />
      ))}
    </div>
  )
}


function Content({ warranty }) {
  const btnRef = useRef(null);
  const [modalOpened, setModalOpened] = useState(false);
  const { formhandler, onSubmit } = useDeleteSalesLocation()

  const ContentComp = ({ name, id }: { name: string, id: string }) => {
    return (<div className='p-2'>Are you sure you want to complete request?
      {name}
      <button onClick={() => onSubmit(id).then()} className='font-semibold text-xl border'>Yes {formhandler.isPending && <Spinner />} </button>
    </div>)
  }

  return (
    <section data-type="section" className="flex items-center gap-3 space-y-2 rounded-lg lg:grid grid-cols-[1fr_1fr_1fr_1fr_1fr_1fr_1fr] lg:gap-2 mt-2">
      <div>
        {"warranty.name"}
      </div>
      <div>{"warranty.tel"}</div>
      <div>
        {"warranty.email"}
      </div>
      <div>{"warranty.purchaseDate"}</div>
      <div>{"warranty.serialNumber"}</div>
      <div>{"warranty.receiptMediaUrl"}</div>
      <div className='flex gap-3'>
        <button onClick={() => setModalOpened(true)}><CheckIcon /></button>
      </div>
      {
        modalOpened && (
          <Modal setModalOpened={setModalOpened} btnRef={btnRef}>
            <ContentComp id={warranty.id} name={warranty.name} />
          </Modal>
        )
      }
    </section>
  )
}



function Paging({ methods }: { methods: UseFormReturn<DocListFilter, any> }) {
  const router = useRouter();
  const [pageSize] = useWatch({
    name: ["paging.size"],
    control: methods.control,
  });
  const { data } = useListWarrantyClaim(methods);

  const total = data?.size;

  return (
    <PageNav
      page={Number(router.query.page) || 1} //
      size={pageSize}
      total={total ?? 0}
      pathname="/shop/warranty"
      query={router.query}
    />
  );
}


function useFormPagination() {
  const methods = useForm<DocListFilter>()
  const { query, isReady } = useRouter();

  useEffect(() => {
    methods.setValue("paging.page", Number(query.page ?? 1));

    // eslint-disable-next-line
  }, [query, isReady]);

  return methods
}